import { render, staticRenderFns } from "./RegularizeOrders.vue?vue&type=template&id=2dbc2396&scoped=true"
import script from "./RegularizeOrders.vue?vue&type=script&lang=js"
export * from "./RegularizeOrders.vue?vue&type=script&lang=js"
import style0 from "./RegularizeOrders.vue?vue&type=style&index=0&id=2dbc2396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc2396",
  null
  
)

export default component.exports